import { BaseModel } from '@lib/common-sdk';
import { Expose } from 'class-transformer';

export class ServiceViewId extends BaseModel {
  @Expose()
  serviceId?: string;
  @Expose()
  active?: boolean;
}
